import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsvExport = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 22,
	viewBox: "0 0 18 22",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#4A5666",
				fillRule: "nonzero",
				d: "M17 5h-3.333A.667.667 0 0 1 13 4.333V1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#4A5666",
				strokeLinejoin: "round",
				strokeWidth: 1.333,
				d: "M13 1H2.333C1.597 1 1 1.597 1 2.333v17.334C1 20.403 1.597 21 2.333 21h13.334c.736 0 1.333-.597 1.333-1.333V5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#4A5666",
				strokeLinejoin: "round",
				strokeWidth: 1.333,
				d: "M13 1v3.333c0 .369.298.667.667.667H17"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#4A5666",
				strokeLinejoin: "round",
				d: "M3.5 9.5h11v9h-11zM4 12.5h10M4 15.5h10M7.5 9v9"
			})
		]
	})
});
export default SvgCsvExport;
